import * as getters from "../../baseQuestion/staticDDL/store/getters";
import * as mutations from "../../baseQuestion/staticDDL/store/mutations";
import * as actions from "../../baseQuestion/staticDDL/store/actions";
import { state as static_ddl_state } from "../../baseQuestion/staticDDL/store/state";

function state() {
	return Object.assign(
		{
			dependent_visible: "q_umfk_major_1",
			dependent_visible_values: ["NUR-AP*X", "NUR-MSN*X"],
			options: [
				{
					value: "1",
					text: "Session 1 - First 7 weeks"
				},
				{
					value: "2",
					text: "Session 2 - Second 7 weeks"
				}
			]
		},
		static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
